import moment from 'moment';

export const openPlannerReports = (
  report: any,
  itemsList: any,
  accountList: any,
  calendarList: any,
  configurationService: any,
  dropdownObjects: any,
  isActiveAccount: boolean
) => {
  const itemNames = itemsList
    .filter((row: any) =>
      dropdownObjects.itemIds.toString().includes(row.data.toString())
    )
    .map((el: any) => el.description);
  const accountNames = accountList
    .filter((row: any) =>
      dropdownObjects.channelIds
        .toString()
        .includes(row.itemAccountId.toString())
    )
    .map((el: any) => el.accountName);
  const weeks = calendarList
    .filter((row: any) =>
      dropdownObjects.calendarIds
        .toString()
        .split(',')
        .includes(row.calendarId.toString())
    )
    .map((row: any) => row.weekStartDate);
  const monthNames: any[] = [];
  const yearNames: any = [];
  weeks.forEach((week: any) => {
    let mName = moment(week).format('MMMM');
    let yName = moment(week).format('YYYY');
    if (!monthNames.includes(mName)) {
      monthNames.push(mName);
    }
    if (!yearNames.includes(yName)) {
      yearNames.push(yName);
    }
  });
  const plannerReportObj: any = configurationService.menuList.find(
    (r: any) => r.selector === 'app-dynamic-report'
  );
  plannerReportObj.name = report.reportName;
  plannerReportObj.report = {
    ...report,
    isPlannerReport: true,
    isActiveAccount: isActiveAccount,
    items: itemNames,
    accounts: accountNames,
    months: monthNames,
    years: yearNames,
    weeks: weeks,
    cycleOneMeasure: 'GDP To Go Total Fcst',
    cycleTwoMeasure: 'Actual ST',
    measureSelect: ['Cycle 1', 'Cycle 2', 'COC Cycle']
  };
  configurationService.plannerReportRenderer.next(plannerReportObj);
};
